


import { Routes, RouterModule } from '@angular/router';
import { RuleComponent } from './rule.component';

const routes: Routes = [
    {
        path: '',
        component: RuleComponent
    },
];

export const RuleRoutes = RouterModule.forChild(routes);
